export default {

    initialised: false,

    init: function() {
        // Don't initialise twice!
        if (this.initialised) {
            return;
        }

        // Validate all forms with the "validate" class
        $('form.validate').parsley({
            trigger: 'change', // Which event to trigger validation on
            errorClass: 'is-invalid', // Class when there are errors
            successClass: 'is-valid', // Class for successful validation
            //errorsMessagesDisabled: false, // Whether to add disable messages on each field
            whitespace: 'trim', // Trim whitespace before validation
            validationThreshold: 1, // Minimum number of chars before validation will fire
            errorTemplate: '<span></span>',
            priorityEnabled: true,

            classHandler: function(field) {
                var tagName = (field.$element.prop('tagName') || '').toLowerCase();
                var type = (field.$element.attr('type') || '').toLowerCase();

            }

        });

        window.Parsley.addValidator('donationAmount', {
            requirementType: 'integer',
            validateString : function(value, requirement) {
                if ( !value ) {
                    return false;
                }

                if ( !/^[0-9]{1,}([,.]{1}[0-9]{1,})?$/.test( value ) ) {
                    return false;
                }

                const valueWithNumericOnly = parseFloat( value.replace( ',', '' ) );

                return valueWithNumericOnly <= requirement;
            },
        });
    }
};